// src/types/entitlement.ts
// Tipos do contrato de ENTITLEMENT por módulo de tenant — eixo SEPARADO das
// permissões de usuário do JWT (premissa #8: ROLE_MASTER bypassa hasPermission,
// mas NÃO bypassa o gate de módulo). Espelha GET /v1/entitlement/features.

// Catálogo de módulos de tenant do backend. Mantido como union aberta na prática
// (hasModule recebe string) para não travar a lista quando o backend crescer.
export type TenantModule = 'PO' | 'ODP' | 'CD' | 'AERP' | 'BBI';

// Resposta 200 do GET /v1/entitlement/features (camelCase).
export interface EntitlementFeatures {
  effectiveStatus: string;
  modules: string[];
  limits: Record<string, string>;
}

// Corpo do erro 403 do backend (snake_case) — usado pelo interceptor de api.ts
// para distinguir "módulo não contratado" de "tenant inteiro bloqueado".
export interface EntitlementForbiddenBody {
  error?: string;
  effective_status?: string;
  reason?: string;
  code?: string;
}

// reasons de 403 que significam "tenant inteiro bloqueado" (status), distintos
// de `modulo_nao_contratado:<MOD>` (só o módulo).
export const TENANT_BLOCKED_REASONS = [
  'sem_entitlement',
  'tenant_suspended',
  'kill_switch',
  'contrato_vencido',
] as const;
